export const load = () => ({
	title: 'Contact Us',
	description:
		"We're here to help you! Questions, comments, and love letters are welcome! Let us know how we can help you gain comfort, quiet, and savings.",
	showTitle: true,
});
